import { render, staticRenderFns } from "./WidgetObjectiveDetails.vue?vue&type=template&id=c82d7342&"
import script from "./WidgetObjectiveDetails.vue?vue&type=script&lang=js&"
export * from "./WidgetObjectiveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports